module.exports = __webpack_public_path__ + "static/media/icons.4a0b7cf5.svg";